import { createContext, useContext, useMemo } from 'react';

/**
 * PermissionProvider.jsx
 *
 * Generic permission layer. For this demo, "permission" simply means
 * "the module id is present in the enabled modules list returned at
 * login". A real backend could instead return a dedicated
 * `permissions` array — this provider would just read that field
 * instead, with no change needed anywhere else in the app.
 */

const PermissionContext = createContext(null);

export function PermissionProvider({ enabledModules = [], children }) {
  const value = useMemo(
    () => ({
      enabledModules,
      can: (moduleId) => enabledModules.includes(moduleId),
    }),
    [enabledModules]
  );

  return <PermissionContext.Provider value={value}>{children}</PermissionContext.Provider>;
}

export function usePermissions() {
  const ctx = useContext(PermissionContext);
  if (!ctx) throw new Error('usePermissions must be used within a PermissionProvider');
  return ctx;
}
